import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import {
  addIncidentDescription,
  addIncidentDetails,
  reset as resetIncidentReportStore,
  setOfflineInitiated,
} from '../../../services/store/modules/incident-report';
import ContactDetailsPage from './ContactDetailsPage/ContactDetailsPage';
import IncidentDescriptionPage from './IncidentDescriptionPage/IncidentDescriptionPage';
import IncidentDetailsPage from './IncidentDetailsPage/IncidentDetailsPage';
import IncidentReportSetLocationPage from './IncidentReportSetLocationPage/IncidentReportSetLocationPage';
import MarinePollutionIncidentPage from './MarinePollutionIncidentPage/MarinePollutionIncidentPage';
import SelectIncidentTypePage from './SelectIncidentTypePage/SelectIncidentTypePage';
import ViewIncidentPage from './ViewIncidentPage/ViewIncidentPage';

const IncidentReportFeature: FC = () => {
  const { path } = useRouteMatch();
  const { state } = useLocation<{
    description?: string;
    incidentDate?: string;
    offlineInitiated?: boolean;
  }>();
  const dispatch = useDispatch();

  useEffect(() => {
    if (state?.incidentDate) {
      dispatch(
        addIncidentDetails({
          tags: [],
          incidentDateTime: state.incidentDate,
        }),
      );
    }
    if (state?.description) {
      dispatch(
        addIncidentDescription({
          description: state.description,
        }),
      );
    }
  }, [dispatch, state?.description, state?.incidentDate]);

  useEffect(
    () => () => {
      dispatch(resetIncidentReportStore());
    },
    [dispatch],
  );

  useEffect(() => {
    if (state?.offlineInitiated) {
      dispatch(setOfflineInitiated());
    }
  }, [dispatch, state?.offlineInitiated]);

  return (
    <Switch>
      {/* Select the type */}
      <Route path={path} exact>
        <SelectIncidentTypePage />
      </Route>

      {/* Marine pollution information page */}
      <Route path={`${path}/marine-pollution`}>
        <MarinePollutionIncidentPage />
      </Route>

      {/* Marine pollution information page */}
      <Route path={`${path}/view/:id`}>
        <ViewIncidentPage />
      </Route>

      {/* Choose the location on the map */}
      <Route path={`${path}/location`}>
        <IncidentReportSetLocationPage />
      </Route>

      {/* Collect details of the incident */}
      <Route path={`${path}/details`}>
        <IncidentDetailsPage />
      </Route>

      {/* Collect description and additional details of the incident */}
      <Route path={`${path}/description`}>
        <IncidentDescriptionPage />
      </Route>

      {/* Complete the rest of the fields */}
      <Route path={`${path}/contact`}>
        <ContactDetailsPage />
      </Route>
    </Switch>
  );
};

export default IncidentReportFeature;
